import { urlConfig } from "../../config/urlConfig";
import { postCall } from "../httpService";

export const getPendingMessageData = async (params: any) => {
  try {
    const response = await postCall(urlConfig.getPendingMessages, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const getDQDeptCount = async () => {
  try {
    const response = await postCall(urlConfig.DQDeptCount, {});
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};